var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: { width: "19.732", height: "19.711", viewBox: "0 0 19.732 19.711" }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M21.389,18.777l-4.72-4.715a7.666,7.666,0,0,0,1.122-4A8.135,8.135,0,0,0,9.826,2.1,7.72,7.72,0,0,0,2.1,9.819a8.136,8.136,0,0,0,7.964,7.956,7.686,7.686,0,0,0,3.89-1.053L18.7,21.464a1.191,1.191,0,0,0,1.681,0l1.178-1.177C22.021,19.825,21.853,19.24,21.389,18.777ZM4.478,9.819A5.345,5.345,0,0,1,9.826,4.475a5.761,5.761,0,0,1,5.588,5.582A5.347,5.347,0,0,1,10.064,15.4,5.762,5.762,0,0,1,4.478,9.819Z",
          transform: "translate(-2.1 -2.101)"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }